import React from 'react';
import { Incident } from '../../pages/law/incidentsData';
import { DashboardIcon } from '../ui/DashboardIcon';
import { StatusPill } from '../ui/StatusPill';
import { getIncidentStatusTone } from './incidentUi';

type IncidentCardProps = {
  incident: Incident;
  onSelect: (incident: Incident) => void;
};

export function IncidentCard({ incident, onSelect }: IncidentCardProps) {
  return (
    <button
      className={`incident-card ${incident.status}`}
      onClick={() => onSelect(incident)}
      type="button"
    >
      <span className="ic-top">
        <span className="ic-id">{incident.id}</span>
        <span className="ic-time">{incident.time}</span>
      </span>
      <span className="ic-body">
        <span className="ic-icon"><DashboardIcon type="alert" /></span>
        <span className="ic-info">
          <strong>{incident.passenger} &middot; Vehicle {incident.vehicle}</strong>
          <span>{incident.note}</span>
          <span className="incident-meta">
            <StatusPill tone={getIncidentStatusTone(incident.status)}>{incident.status}</StatusPill>
            <span className="incident-location">
              Location {incident.lat.toFixed(4)}, {incident.lng.toFixed(4)}
            </span>
          </span>
        </span>
      </span>
    </button>
  );
}
